
export const handleDayPicker = (day, objData) => {
  const selectedDate = day;
  let newState;
  if (objData.id) {
    newState = (prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.group]: [
          ...prevState.newFormData[objData.group].map((element) =>
            element.id === objData.id
              ? {
                  ...element,
                  [objData.prop]: selectedDate,
                }
              : element
          ),
        ],
      },
    });
    return newState;
  }

  newState = (prevState) => ({
    newFormData: {
      ...prevState.newFormData,
      [objData.group]: {
        ...prevState.newFormData[objData.group],
        [objData.prop]: selectedDate,
      },
    },
  });
  return newState;
};
